module.exports = __webpack_public_path__ + "catalog/items/sofa-single/sofa.mtl";